const SILHOUETTES = {
  hoodie: (
    <>
      <path d="M35 34 Q50 14 65 34 L78 42 L74 82 L64 78 L64 106 L36 106 L36 78 L26 82 L22 42 Z" />
      <path d="M40 36 Q50 26 60 36" />
      <path d="M46 52 V70 M54 52 V70" />
    </>
  ),
  tee: <path d="M32 28 L44 22 Q50 28 56 22 L68 28 L82 38 L74 52 L66 47 L66 104 L34 104 L34 47 L26 52 L18 38 Z" />,
  crewneck: (
    <>
      <path d="M32 28 L44 22 Q50 27 56 22 L68 28 L84 40 L78 90 L68 86 L68 104 L32 104 L32 86 L22 90 L16 40 Z" />
      <ellipse cx="50" cy="26" rx="7" ry="4" />
    </>
  ),
  jacket: (
    <>
      <path d="M34 28 L46 22 Q50 26 54 22 L66 28 L80 38 L75 86 L66 82 L66 106 L34 106 L34 82 L25 86 L20 38 Z" />
      <path d="M50 26 V106 M40 44 L46 44 M54 44 L60 44" />
    </>
  ),
  pants: <path d="M34 16 L66 16 L70 106 L56 106 L52 50 L48 106 L30 106 Z M34 24 L66 24" />,
  cap: (
    <>
      <path d="M28 62 Q50 34 72 62 L72 70 L28 70 Z" />
      <path d="M72 64 L96 70 L94 77 L72 70" />
    </>
  ),
};

export default function ProductImage({ product, ratio = "aspect-[3/4]", className = "", tag, fit = "cover" }) {
  if (product?.image_url) {
    return (
      <div className={`${ratio} overflow-hidden bg-coal ${className}`}>
        <img
          src={product.image_url}
          alt={product.name}
          className={`h-full w-full transition-transform duration-700 ease-out group-hover:scale-105 ${fit === "contain" ? "object-contain p-6 sm:p-10" : "object-cover"}`}
        />
      </div>
    );
  }
  const angel = product?.angel || "111";
  const garment = product?.garment || "tee";
  return (
    <div
      data-testid={`product-image-${product?.id || "placeholder"}`}
      className={`${ratio} relative overflow-hidden bg-gradient-to-b from-[#16161a] via-[#101013] to-[#0a0a0c] ${className}`}
    >
      <div className="absolute inset-0 opacity-[0.35]" style={{ background: "radial-gradient(ellipse at 50% 35%, rgba(255,255,255,0.09), transparent 60%)" }} />
      <svg viewBox="0 0 100 120" className="absolute left-1/2 top-1/2 h-[62%] -translate-x-1/2 -translate-y-1/2 text-bone/25 transition-transform duration-700 ease-out group-hover:scale-105" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" strokeLinecap="round">
        {SILHOUETTES[garment] || SILHOUETTES.tee}
      </svg>
      <span className="pointer-events-none absolute -bottom-5 right-1 select-none font-display text-[7rem] font-extrabold leading-none text-bone/[0.05]">{angel}</span>
      <span className="absolute right-3 top-3 font-mono text-[9px] tracking-[0.25em] text-bone/30">{tag || "ALIGNDEPT"}</span>
      <span className="absolute bottom-3 left-3 font-mono text-[9px] tracking-[0.25em] text-bone/25">SAMPLE — PHOTO FORTHCOMING</span>
      <svg className="absolute bottom-3 right-3 h-4 w-4 text-bone/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 4v16M4 12h16" />
      </svg>
    </div>
  );
}
